<div *ifRoles='placeholderDashboardRoles'>
  <div class="containerX">
  </div>
  <div class="containerX">
    <div class="container">
      <div fxLayoutAlign="center center" fxFlex="100%"></div>

    </div>
    <div class="container">
      <div fxLayoutAlign="center center" fxFlex="100%" class="mt-0">
        <h1>Placeholder for authenticated page. Displaying claims </h1>
      </div>
    </div>
    <div class="container">


      <div fxLayoutAlign="center center" fxFlex="100%">
        <mat-table [dataSource]="dataSource" class="mat-elevation-z8" *ngIf="loginDisplay">

          <!-- Claim Column -->
          <ng-container matColumnDef="claim">
            <mat-header-cell *matHeaderCellDef class="mat-column-claim"> Claim </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.claim}} </mat-cell>
          </ng-container>

          <!-- Value Column -->
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef class="mat-column-value"> Value </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.value}} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

        </mat-table>
      </div>

    </div>

  </div>
</div>

<app-courses *ifRoles="learnerRole"></app-courses>
<app-admin *ifRoles="adminRole"></app-admin>